module.exports = __webpack_public_path__ + "sunsemweb/img/banner3.507fdca5.png";